export default "__VITE_ASSET__Cyvqy2ka__"